<div class="bg-cover bg-center flex flex-row min-h-screen justify-center items-center" style="background-image: url('assets/landing.jpg')">
</div>
